// types.js
export const CHAT_USER_LOGIN_REQUEST = 'CHAT_USER_LOGIN_REQUEST'
export const CHAT_USER_LOGIN_SUCCESS = 'CHAT_USER_LOGIN_SUCCESS'
export const CHAT_USER_LOGIN_FAILURE = 'CHAT_USER_LOGIN_FAILURE'
